import classNames from "classnames";
import PropTypes from "prop-types";

function TabButton({ onClick, children, isActive, className }) {
  return (
    <button
      className={classNames(
        { "bg-tertiary-400 text-white": isActive },
        `${className} w-full cursor-pointer rounded-[0.5rem] bg-grayDisplay-600 px-[1.688rem] py-[0.2rem] text-[1rem] text-grayDisplay-700 transition-colors delay-75 duration-150 lg:py-[0.813rem] lg:hover:bg-tertiary-400 lg:hover:text-white`
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

TabButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default TabButton;
